import { render } from "./list.vue?vue&type=template&id=08fb1bd4"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=08fb1bd4&lang=css"
script.render = render

export default script